/**
 * SB2-W-16 — Per-row progress indicator for the Projects list.
 *
 * The `progressPct` field is computed BE-side as
 *   round(100 * COUNT(positions WHERE state=COMPLETED)
 *              / NULLIF(COUNT(positions WHERE state IN
 *                    (OPEN,SCHEDULED,IN_PROGRESS,COMPLETED)), 0))
 * Returned as `0..100`. We render a horizontal bar with the percentage
 * label inline so the column reads at a glance.
 */
import { type ReactElement } from "react";
import { Box, LinearProgress, Typography } from "@mui/material";

export function ProjectProgressBar({ value }: { value: number }): ReactElement {
  const clamped = Math.max(0, Math.min(100, Math.round(value)));
  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        alignItems: "center",
        gap: 1,
      }}
      data-progress={clamped}
    >
      <LinearProgress
        variant="determinate"
        value={clamped}
        sx={{
          flex: 1,
          height: 6,
          borderRadius: 3,
        }}
        aria-label={`Progress ${String(clamped)} percent`}
      />
      <Typography
        variant="caption"
        sx={{
          minWidth: 36,
          textAlign: "right",
          fontVariantNumeric: "tabular-nums",
        }}
      >
        {clamped}%
      </Typography>
    </Box>
  );
}
